import { render, staticRenderFns } from "./SidColor.vue?vue&type=template&id=191bc81e"
import script from "./SidColor.vue?vue&type=script&lang=js"
export * from "./SidColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports